<template>
  <!-- Email registration -->
  <div
    :class="[
      'info-boires__container mt-60',
      isMobileLayout ? 'info-boires__container--mobile mt-90' : '',
    ]"
  >
    <div class="container text-left subscription-form">
      <div class="flex">
        <h2 class="title text-uppercase pt-38">
          {{ registerFormTitle }}
        </h2>
        <el-image
          :class="[isMobileLayout ? 'ml-8 pt-38' : 'ml-12 pt-35']"
          :style="{ width: isMobileLayout ? '89px' : '128px' }"
          :src="images.logoRed.src"
          :fit="'contain'"
        />
      </div>
      <div
        :class="isMobileLayout? 'info-boires__subtitle--mobile mt-4' : 'info-boires__subtitle'"
      >
        {{ registerFormSubTitle }}
      </div>

      <mq-layout :mq="['xs', 'sm', 'md']">
        <el-form
          ref="registrationForm"
          :model="person"
          :rules="registerRules"
          v-if="reRender"
        >
          <el-row>
            <el-col :span="12" class="pr-10">
              <el-form-item prop="firstName">
                <el-input
                  id="firstName"
                  v-model="newsLetterDetail.newsLfirstName"
                  :placeholder="registerFormFirstName"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="lastName">
                <el-input
                  id="lastName"
                  v-model="newsLetterDetail.newsLlastName"
                  :placeholder="registerFormLastName"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item prop="email">
            <el-input
              id="email"
              v-model="newsLetterDetail.newsLemail"
              :placeholder="registerFormEmail"
            />
          </el-form-item>
          <div class="text-right mt-15">
            <el-button
              type="primary"
              :class="[
                isMobileLayout
                  ? 'button__read-all--mobile'
                  : 'button__read-all',
              ]"
              @click="openNewsLetterModal"
            >
              {{ ctaRegisterForm }}
            </el-button>
          </div>
        </el-form>
      </mq-layout>
      <mq-layout mq="lg+">
        <el-form
          ref="registrationForm"
          class="flex"
          :model="person"
          :rules="registerRules"
          v-if="reRender"
        >
          <el-form-item prop="firstName" class="mr-10" style="width: 200px">
            <el-input
              id="firstName"
              v-model="newsLetterDetail.newsLfirstName"
              :placeholder="registerFormFirstName"
            />
          </el-form-item>
          <el-form-item prop="lastName" class="mr-10" style="width: 200px">
            <el-input
              id="lastName"
              v-model="newsLetterDetail.newsLlastName"
              :placeholder="registerFormLastName"
            />
          </el-form-item>
          <el-form-item prop="email" class="mr-10" style="width: 382px">
            <el-input
              id="email"
              v-model="newsLetterDetail.newsLemail"
              :placeholder="registerFormEmail"
            />
          </el-form-item>
          <el-button
            type="primary"
            class="button__read-all mt-8"
            @click="openNewsLetterModal"
          >
            <!-- @click="handleRegistration" -->
            {{ ctaRegisterForm }}
          </el-button>
        </el-form>
      </mq-layout>
      <el-dialog
        :visible.sync="dialogFormVisible"
        width="500"
        :header="false"
        class="news-letter-el-dialog"
      >
        <h1 v-if="country == 'ON'">{{ newsletterTitle }}</h1>
        <div v-if="country == 'QC'" class="newsletter-img-qc">
          <img src="@/assets/images/logo/logo-white.png" />
        </div>
        <h4 v-if="country == 'ON'">{{ $t("home.newsletter.title1") }}</h4>
        <h4 v-if="country == 'QC'">{{ $t("home.newsletter.titleQC") }}</h4>
        <el-form
          ref="newsLetter"
          :model="newsLetterDetail"
          :rules="newsLetterRules"
        >
          <el-form-item prop="newsLemail">
            <label class="title">
              {{ registerFormEmail }}
            </label>
            <el-input
              id="newsLemail"
              v-model="newsLetterDetail.newsLemail"
              :placeholder="registerFormEmail"
            />
          </el-form-item>

          <el-form-item prop="newsLfirstName">
            <label class="title">
              {{ registerFormFirstName }}
            </label>
            <el-input
              id="newsLfirstName"
              v-model="newsLetterDetail.newsLfirstName"
              :placeholder="registerFormFirstName"
            />
          </el-form-item>
          <el-form-item prop="newsLlastName">
            <label class="title">
              {{ registerFormLastName }}
            </label>
            <el-input
              id="newsLlastName"
              v-model="newsLetterDetail.newsLlastName"
              :placeholder="registerFormLastName"
            />
          </el-form-item>
          <el-form-item prop="nlProvince">
            <label class="title">
              {{ newsletterProvince }}
            </label>
            <el-input
              id="nlProvince"
              v-model="newsLetterDetail.newsLprovince"
              :placeholder="newsletterProvince"
            />
          </el-form-item>
          <el-form-item prop="likeOption">
            <label class="title">
              {{ selectlikeOption }}
            </label>
            <div class="field-group groups">
              <el-checkbox-group v-model="newsLetterDetail.newsLlikeOptions">
                <ul class="interestgroup_field checkbox-group">
                  <li class="!margin-bottom--lv2" v-for="(data, index) in selectedCheckboxOptions" :key="index">
                    <el-checkbox :label="data.text" :value="data.value" name="type">
                    </el-checkbox>
                  </li>
                </ul>
              </el-checkbox-group>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              native-type="submit"
              class="ctaSubmit"
              @click="submitNewsletter"
              >{{ $t('home.newsletter.subscribe') }}</el-button
            >
            <el-button @click="dialogFormVisible = false">Cancel</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { get } from "@/utils/lodash";
import layoutUtils from "@/utils/layout-utils";
import imgLogoRed from "@/assets/images/logo/logo-red.png";
import axios from "axios";
import { Notification } from 'element-ui';

export default {
  data() {
    return {
      dialogFormVisible: false,
      newsLetterDetail: {
        newsLfirstName: null,
        newsLlastName: null,
        newsLemail: null,
        newsLprovince: null,
        newsLlikeOptions: [],
      },
      userLanguage: "fr",
      images: {
        logoRed: {
          src: imgLogoRed,
        },
      },
      person: {
        firstName: null,
        lastName: null,
        email: null,
      },
      newsLetterRules: {
        newsLemail: [
          {
            required: true,
            message: this.$i18n.t(
              "users.deliveryAddress.formRequiredMsg.email"
            ),
          },
        ],
        newsLfirstName: [
          {
            required: true,
            message: this.$i18n.t(
              "users.deliveryAddress.formRequiredMsg.firstName"
            ),
          },
        ],
        newsLlastName: [
          {
            required: true,
            message: this.$i18n.t(
              "users.deliveryAddress.formRequiredMsg.lastName"
            ),
          },
        ],
      },
      registerRules: {
        newsLfirstName: [
          {
            required: true,
            message: this.$i18n.t(
              "users.deliveryAddress.formRequiredMsg.firstName"
            ),
          },
        ],
        newsLlastName: [
          {
            required: true,
            message: this.$i18n.t(
              "users.deliveryAddress.formRequiredMsg.lastName"
            ),
          },
        ],
        newsLemail: [
          {
            required: true,
            message: this.$i18n.t(
              "users.deliveryAddress.formRequiredMsg.email"
            ),
          },
        ],
      },
      reRender: true,
    };
  },
  computed: {
    ...mapState("configuration", ["actionBar"]),
    ...mapState("user", ["user"]),
    country() {
      return get(this.actionBar, "country");
    },
    newsletterTitle() {
      return this.$i18n.t("home.newsletter.title");
    },
    newsletterProvince() {
      return this.$i18n.t("home.newsletter.provincePlaceholder");
    },
    selectlikeOption() {
      return this.$i18n.t("home.newsletter.iLike");
    },
    registerFormTitle() {
      return this.$i18n.t("home.homeView.infoRegisterForm.title");
    },
    registerFormSubTitle() {
      return this.$i18n.t("home.homeView.infoRegisterForm.subTitle");
    },
    registerFormFirstName() {
      return this.$i18n.t("home.homeView.infoRegisterForm.firstName");
    },
    registerFormLastName() {
      return this.$i18n.t("home.homeView.infoRegisterForm.lastName");
    },
    registerFormEmail() {
      return this.$i18n.t("home.homeView.infoRegisterForm.email");
    },
    ctaRegisterForm() {
      return this.$i18n.t("home.homeView.infoRegisterForm.cta");
    },
    isMobileLayout() {
      return layoutUtils.isMobileLayout(this.$mq);
    },
    selectedCheckboxOptions() {
      let options = [];
      if (this.country == 'QC') {
        options = [
          { text: this.$i18n.t("home.newsletter.Qcop1"), value: 'arrivalAtSAQ'},
          { text: this.$i18n.t("home.newsletter.Qcop2"), value: 'IParrival'},
          { text: this.$i18n.t("home.newsletter.Qcop3"), value: 'ourEvents'},
          { text: this.$i18n.t("home.newsletter.Qcop4"), value: 'ourRestaurant'},
        ];
        return options;
      }
      options = [
          { text: this.$i18n.t("home.newsletter.OnOp1"), value: 'privateOrders'},
          { text: this.$i18n.t("home.newsletter.OnOp2"), value: 'events'},
          { text: this.$i18n.t("home.newsletter.OnOp3"), value: 'ourRestaurant'},
          { text: this.$i18n.t("home.newsletter.OnOp4"), value: 'lcbo'},
      ]
      return options;
    }
  },
  methods: {
    openNewsLetterModal() {
      this.$refs.registrationForm.validate().then(async (valid) => {
        if(valid) {
          this.dialogFormVisible = true;
        }
      })
    },
    async submitNewsletter(e) {
      e.preventDefault();
      this.$refs.newsLetter.validate().then(async (valid) => {
        let listId;
        if (this.country == 'ON') {
          listId = window.processEnv.VUE_APP_NEWSLETTERLISTID_ON;
        } else if(this.country == 'QC') {
          listId = window.processEnv.VUE_APP_NEWSLETTERLISTID_QC;
        }
        if (valid) {
          const url = `${window.processEnv.VUE_APP_NEWSLETTER_URL}/${listId}/members/`;
          let data = {
            email_address: this.newsLetterDetail.newsLemail,
            province: this.newsLetterDetail.newsLprovince,
            provinceOption: this.newsLetterDetail.newsLlikeOptions,
            status: "subscribed",
            merge_fields: {
              FNAME: this.newsLetterDetail.newsLfirstName,
              LNAME: this.newsLetterDetail.newsLlastName,
            },
          };
          const config = {
            headers: {
              Authorization: window.processEnv.VUE_APP_NEWSLETTER_API_KEY
            }
          };
          try {
              await axios.post(url, data, config).then(() => {
                this.message = this.$i18n.t("home.newsletter.success");
                Notification({
                  title: 'Success',
                  message: this.$i18n.t("home.newsletter.success"),
                  type: 'success'
                });
                const userKey = `newsletter_${this.newsLetterDetail.newsLemail}`;
                localStorage.setItem(userKey, true);
                this.dialogFormVisible = false;
                this.newsLetterDetail.newsLfirstName = null
                this.newsLetterDetail.newsLlastName = null;
                this.newsLetterDetail.newsLemail = null;
                this.newsLetterDetail.newsLprovince = null;
                this.newsLetterDetail.newsLlikeOptions = [];

              })
            } catch (error) {
            if (error.response && error.response.status === 400 && error.response.data.title === "Member Exists") {
              Notification({
                title: 'Info',
                message: this.$i18n.t("home.newsletter.info"),
                type: 'info'
              });
              const userKey = `newsletter_${this.newsLetterDetail.newsLemail}`;
              localStorage.setItem(userKey, true);
              this.message = this.$i18n.t("home.newsletter.info");
              this.dialogFormVisible = false;
            } else {
                Notification({
              title: 'Error',
              message: this.$i18n.t("home.newsletter.errormsg"),
              type: 'error'
            });
              this.message = this.$i18n.t("home.newsletter.errormsg");
              this.dialogFormVisible = false;
              this.person = {};
            }
          }
        }
      })
    },
    reRenderForm() {
      this.reRender = false;
      this.$nextTick(() => {
        this.reRender = true;
      });
    },
  },
  mounted() {
    const rememberedUser = localStorage.getItem("user");
    if (rememberedUser) {
      const userData = JSON.parse(rememberedUser);
      this.newsLetterDetail.newsLfirstName = userData.user.firstName;
      this.newsLetterDetail.newsLlastName = userData.user.lastName;
      this.newsLetterDetail.newsLemail = userData.user.email;
    }
    this.$root.$on("chanLang", () => {
      this.reRenderForm();
      this.registerRules = {
        firstName: [
          {
            required: true,
            message: this.$i18n.t(
              "users.deliveryAddress.formRequiredMsg.firstName"
            ),
          },
        ],
        lastName: [
          {
            required: true,
            message: this.$i18n.t(
              "users.deliveryAddress.formRequiredMsg.lastName"
            ),
          },
        ],
        email: [
          {
            required: true,
            message: this.$i18n.t(
              "users.deliveryAddress.formRequiredMsg.email"
            ),
          },
        ],
      };
      this.newsLetterRules = {
        newsLemail: [
          {
            required: true,
            message: this.$i18n.t(
              "users.deliveryAddress.formRequiredMsg.email"
            ),
          },
        ],
        newsLfirstName: [
          {
            required: true,
            message: this.$i18n.t(
              "users.deliveryAddress.formRequiredMsg.firstName"
            ),
          },
        ],
        newsLlastName: [
          {
            required: true,
            message: this.$i18n.t(
              "users.deliveryAddress.formRequiredMsg.lastName"
            ),
          },
        ],
      };
    });
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/variables.scss";

.title {
  color: $color-on-background;
}
.info-boires__container {
  background-color: $color-background-area2;
  height: 226px;
}
.info-boires__container--mobile {
  height: 335px !important;
}
.info-boires__subtitle {
  letter-spacing: 0.5px !important;
  line-height: 20px;
  font-weight: 300;
  height: 18px;
  color: #272421;
  width: 419px;
  height: 42px;
}
.info-boires__subtitle--mobile {
  letter-spacing: 0.5px !important;
  line-height: 20px;
  font-weight: 300;
  height: 18px;
  color: #272421;
  width: auto;
  height: 42px;
}
.button__read-all {
  height: 40px;
  font-size: 16px;
  width: 138px;
}
.button__read-all--mobile {
  height: 35px;
  font-size: 14px;
  width: 122px;
  padding-left: 8px !important;
}
.subscription-form {
  // sm -
  // min-width: 343px;
}
</style>
